import Logo from '../../components/Logo';
import '../../App.css';
import {QrScanner} from '@yudiel/react-qr-scanner';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useState,useEffect } from 'react';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import api from '../../api'
import TextField from '@mui/material/TextField';
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import DeviceInfoDialog from '../../components/DeviceInfoDialog';
import LogoutButton from '../../components/LogoutButton';
import Typography from '@mui/material/Typography';

const MatchCodes =()=>{
const [token,setToken] = useState('')
const [log, setLog] = useState('');
const [buttonLabel, setButtonLabel] = useState('SCAN PCB QR CODE');
const [pcbQrDecoded, setPcbQrDecoded] = useState(false);
const [boxQrDecoded, setBoxQrDecoded] = useState(false);
const [openScanner, setOpenScanner] = useState(false);
const [pcbQrCodeStr, setPcbQrCodeStr] = useState('');
const [boxQrCodeStr, setBoxQrCodeStr] = useState('');
const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
const [detailsOpen, setDetailsOpen] = useState(false);
const [selectedDevEui, setSelectedDevEui] = useState(null);
const [isScanningForQC, setIsScanningForQC] = useState(false);
const [scanningStatus, setScanningStatus] = useState('');
const navigate = useNavigate();
useEffect(()=>{
  var localToken = localStorage.getItem("jwt");
  if(localToken && localToken.length>0){
    setToken(localToken)
  }
},[])


const onDecode = (code) => {
  console.log("code", code)
  console.log("isScanningForQC", isScanningForQC)
  if (isScanningForQC) {
    var lengTest = code.length > 0
    if (lengTest) {
      let deviceId;
      
      // URL formatındaki QR kodu kontrolü
      if (code.includes("http")) {
        var splitted = code.split('qrdevice/')
        if (splitted.length > 1) {
          var box = splitted[1]
          var boxCodes = box.split('-')
          deviceId = boxCodes[1] + boxCodes[2]
        }
      } 
      else if (code.match(/^[0-9A-Fa-f]{16}$/)) {
        deviceId = code
      }

      if (deviceId) {
        setOpenScanner(false)
        setSelectedDevEui(deviceId)
        setDetailsOpen(true)
        setIsScanningForQC(false)
      } else {
        console.log("Invalid QR code format")
        onError("Invalid QR code format")
      }
    }
  } else if (!pcbQrDecoded) {
    var incTest = code.includes("http")
    var lengTest = code.length>0
    if(!incTest && lengTest){
      setPcbQrCodeStr(code)
      setPcbQrDecoded(true);
      setOpenScanner(false);
      setButtonLabel("SCAN BOX QR CODE");
    }
  } else if(pcbQrDecoded && !boxQrDecoded){
    var incTest = code.includes("http")
    var lengTest = code.length>0
    if(incTest && lengTest){
      var splitted = code.split('qrdevice/')
      var box = splitted[1]
      var boxCodes = box.split('-')
      var boxCode = boxCodes[1]+boxCodes[2]
      setBoxQrCodeStr(boxCode)
      setBoxQrDecoded(true);
      setOpenScanner(false);
      setButtonLabel("MATCH QR CODES");
      setSelectedDevEui(boxCode);
      //setDetailsOpen(true);
    }else{
      onError("Invalid QR code format")
    }
  }
}

const onError = (err)=>{
  window.showToast(err, 'error');
}

const onSuccess = (msg)=>{
  window.showToast(msg, 'success');
}

const onWarning = (msg)=>{
  window.showToast(msg, 'warning');
}

const onLogin = ()=>{
  if(email.length>0 && password.length>0){
    api.post(`/login`,{email,password})
    .then((res)=>{
      const token = res.data.token
      localStorage.setItem("jwt",token);
      setToken(token)
      onSuccess('Login Successfully !')
    }).catch((err)=>{
      var msg = err.response.data.error
      onError(msg)
    })
  }else {
    onWarning("All field required.")
  }
}

const resetAllStates = () => {
  setOpenScanner(false);
  setPcbQrDecoded(false);
  setBoxQrDecoded(false);
  setPcbQrCodeStr('');
  setBoxQrCodeStr('');
  setButtonLabel('SCAN PCB QR CODE');
  setScanningStatus('');
  setSelectedDevEui(null);
  setDetailsOpen(false);
  setIsScanningForQC(false);
};

const onScanForQC = () => {
  resetAllStates();
  setIsScanningForQC(true);
  setOpenScanner(true);
  setScanningStatus('Scanning for Quality Control');
};

const onQrScannerOpen = () => {
  if (isScanningForQC) {
    resetAllStates();
    setOpenScanner(true);
    setScanningStatus('Scanning PCB QR Code');
    return;
  }
  
  if (openScanner) {
    resetScanStates();
    return;
  }
  
  if(!boxQrDecoded || !pcbQrDecoded){
    setOpenScanner(true);
    setScanningStatus(pcbQrDecoded ? 'Scanning Box QR Code' : 'Scanning PCB QR Code');
  } else if(boxQrDecoded && pcbQrDecoded && pcbQrCodeStr.length>0 && boxQrCodeStr.length>0){
    if(token.length>0){
      const postData = {dev_eui:pcbQrCodeStr,qr_code:boxQrCodeStr};
      api.post('/match_qr_code',postData, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + localStorage.getItem("jwt"),
        }
      })
      .then((res)=>{
        onSuccess(res.data.message)
        resetScanStates();
      }).catch((err)=>{
        if(err.response.status === 401){
          localStorage.removeItem("jwt")
          setToken('')
          onError("Session expired. Please login again.")
          return;
        }

        // Hata kodlarına göre özel mesajlar
        const errorCode = err.response?.data?.code;
        let errorMessage = err.response?.data?.error || "An error occurred";

        switch(errorCode) {
          case 'WAITING_GNSS':
            errorMessage = "Device is waiting for GNSS data. Please try again later.";
            break;
          case 'ALREADY_COMPLETED':
            errorMessage = "This device is already completed and matched.";
            break;
          case 'HAS_ERROR':
            errorMessage = "This device has errors and cannot be matched.";
            break;
          case 'ALREADY_MATCHED':
            errorMessage = "This QR code is already matched with this device.";
            break;
        }

        onError(errorMessage)
        console.error("QR Match Error:", err.response?.data);
      });
    } else {
      onWarning("Please login to continue.")
      localStorage.removeItem("jwt")
      setToken('')
    }
  }
}

const resetScanStates = () => {
  setOpenScanner(false);
  setPcbQrDecoded(false);
  setBoxQrDecoded(false);
  setPcbQrCodeStr('');
  setBoxQrCodeStr('');
  setButtonLabel('SCAN PCB QR CODE');
  setScanningStatus('');
};

  return (
    <div className="App">
      <Logo />
      <LogoutButton />
      <header className="App-header">
        {token.length>0 ?(
        <div>
          <Button  variant="contained" onClick={()=>navigate("/matchedlist")}>Matched List</Button>  
          <Button 
            variant="contained" 
            onClick={onScanForQC}
            sx={{ ml: 2 }}
          >
            Scan For QC
          </Button>
          <p style={{color:'black'}}>
            Mimiq TRACK - MFG - Qr Match
          </p>
          {openScanner && (
            <Typography 
              variant="subtitle1" 
              sx={{ 
                color: 'primary.main',
                fontWeight: 'medium',
                my: 1
              }}
            >
              {scanningStatus}
            </Typography>
          )}
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={pcbQrDecoded} />} label='PCB QR CODE' disabled={true} sx={{ '& .MuiSvgIcon-root': { fontSize: 48 } }} />
            {pcbQrCodeStr.length>0 ? (
              <div>
                <p style={{color:'black'}}>
                PCB QR : {pcbQrCodeStr}
                </p>
              </div>)  : <div/>}
            {pcbQrDecoded ? (
              <FormControlLabel control={<Checkbox checked={boxQrDecoded} />} label="BOX QR CODE" disabled={true} sx={{ '& .MuiSvgIcon-root': { fontSize: 48 } }} />
            ):<div></div>}
             {boxQrCodeStr.length>0 ? (
              <div>
                <p style={{color:'black'}}>
                BOX QR : {boxQrCodeStr}
                </p>
              </div>)  : <div/>}
        <Button  variant="contained" onClick={()=>onQrScannerOpen()}>{buttonLabel}</Button>      
        </FormGroup>
       
        {openScanner ? (
          <div>
            <p style={{color:'black'}}>
           QR Scan Result : {log}
        </p>  
          <QrScanner 
          scanDelay={500}
            onDecode={(result) => onDecode(result)}
            onError={(error) => onError(error)}
          />
          </div>
        ):<div/>}
       </div>) : <div>
        <p style={{color:'black'}}>
        MFG QR Match - Login
          </p>
          <Grid container spacing={2} >
            <Grid item xs={12}>
          <TextField  id="outlined-basic" value={email} onChange={(val)=>setEmail(val.target.value)} label="Email Address" variant="outlined" />
          </Grid>
          <Grid item xs={12}>
          <TextField  id="outlined-basic" value={password} onChange={(val)=>setPassword(val.target.value)} label="Password" type="password" variant="outlined" />
          </Grid>
          <Grid item xs={12}>
          <Button  variant="contained" onClick={()=>onLogin()}>Login</Button>      
          </Grid>
          </Grid>
       </div> }
      </header>
      <DeviceInfoDialog 
        open={detailsOpen}
        onClose={() => {
          setDetailsOpen(false);
          setSelectedDevEui(null);
        }}
        devEui={selectedDevEui}
        isMatchCodesPage={true}
      />
    </div>
  );
}

export default MatchCodes;